import store from '@/store'

export const realEstateCheck = () => {
  Promise.resolve(localStorage.getItem('access_roles')).then(async (role) => {
    // Compared per role, not as the whole string: a user linked to the checklist carries
    // ROLE_REAL_ESTATE plus ROLE_COMPANY, and an exact match would skip them.
    if (!(role || '').split(',').includes('ROLE_REAL_ESTATE')) return

    try {
      store.dispatch('fetchCurrentRealEstate', role)
    } catch (error) {
      error.data
        ? store.dispatch('showErrorMessage', error.data.message)
        : store.dispatch('showErrorMessage', error.message)
    }
  })
}
